
import App from './components/app';
import  sAction  from 'sAction'
import * as customFunctions from "./action/exportConfig";


sAction.addFunctions(customFunctions);
sAction.appComponent = App;